<template>
  <cpheader></cpheader>
  <div id="content" style="padding: 35px 0 0 0;">
    <div class="container"><!-- Container Geral-->
        <cp-menu></cp-menu>
        <div class="page-content-wrapper">
            <div class="page-content">
                <div class="col-md-12">
                    <div class="row">
                        <router-view></router-view>                   
                    </div>    
                </div><!-- Fim Conteiner Geral-->
                
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Cpheader from './layout/header/header.vue'
import CpMenu from './layout/sidebarmenu/menu.vue'
import Cprodape from './layout/rodape/footer.vue'

export default {
  data () {
    return {
    
    }
  },
  components:{
    Cpheader, CpMenu, Cprodape
  },
  ready(){
    $.getScript('./src/assets/assets-metronic/admin/layout4/scripts/layout.js');
    
  }

}
</script>

<style>
.loader-wrapper{
  position: relative !important;
  margin: 20% auto 0;
  width: 200px;
  right: 0 !important;
  bottom: 0 !important;
  display: block !important;
}
.wrapper{
  width: 30px !important;
  height: 30px !important;
}

.spinner-circle{
  border-radius: 50% !important;
  border-color: #333333 !important;
}

</style>



// WEBPACK FOOTER //
// App.vue?ec1f2c60